import React from 'react';

import fr from 'facet-rest';
import PropTypes from 'prop-types';
import Container from './Container';
import { SmartAllocationCustomizationProvider } from './Context';

const SmartAllocationCustomizationComponent = ({ sacRelationship }) => {
  return (
    <SmartAllocationCustomizationProvider relationship={sacRelationship} groupsRelationshipName={fr.relationships.groups.name}>
      <Container />
    </SmartAllocationCustomizationProvider>
  );
};

SmartAllocationCustomizationComponent.propTypes = {
  sacRelationship: PropTypes.object.isRequired,
};

export default SmartAllocationCustomizationComponent;
